import React from "react";

// Función para calcular el tiempo relativo en español
function formatTimeAgo(date) {
  const seconds = Math.floor((new Date() - new Date(date)) / 1000);
  const intervals = [
    { label: "año", seconds: 31536000 },
    { label: "mes", seconds: 2592000 },
    { label: "semana", seconds: 604800 },
    { label: "día", seconds: 86400 },
    { label: "hora", seconds: 3600 },
    { label: "minuto", seconds: 60 },
  ];

  for (const interval of intervals) {
    const amount = Math.floor(seconds / interval.seconds);
    if (amount >= 1) {
      const pluralLabel =
        interval.label === "mes" && amount > 1
          ? "meses"
          : interval.label + (amount > 1 ? "s" : "");
      return `Hace ${amount} ${pluralLabel}`;
    }
  }
  return "Justo ahora";
}

export default function Videos({ videos, onVideoClick }) {
  return (
    <div className="grid grid-cols-1 gap-6 p-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {videos.map((video, index) => (
        <div
          key={index}
          onClick={() => onVideoClick(video)}
          className="transform cursor-pointer overflow-hidden rounded-lg bg-white shadow-lg transition-transform hover:scale-105"
        >
          <img
            src={video.thumbnail}
            alt={video.title}
            className="h-48 w-full object-cover"
          />
          <div className="p-4">
            <h3 className="text-lg font-semibold">{video.title}</h3>
            <p className="mb-2 text-sm text-gray-600">{video.description}</p>
            <div className="flex items-center justify-between text-sm text-gray-500">
              <span>{video.likes} Me gusta</span>
              <span>{video.views} vistas</span>
            </div>
            <div className="mt-1 text-xs text-gray-400">
              {formatTimeAgo(video.publishedAt)}
            </div>
            {/* Etiqueta condicional para el tipo de reproducción */}
            {/* <div
              className={`mt-2 rounded px-2 py-1 text-center text-xs font-semibold ${video.isFree ? "bg-green-100 text-green-800" : "bg-yellow-100 text-yellow-800"}`}
            >
              {video.isFree ? "Reproducción gratuita" : "Requiere donativo"}
            </div> */}
          </div>
        </div>
      ))}
    </div>
  );
}
